import { useEffect, useState } from 'react'
import { humanReadableDate, strJSX } from '../../app/utils'
import './BLTReviewForm.styles.scss'

const BLTReviewForm = (props) => {
    const {data, isReadOnly, review, hideDecisionCheckbox, showConfirmation, confirmationMessage, documentData} = props
    let elements = []

    const [itemReview, setItemReview] = useState((data && ("review" in data)) ? data.review : review)
    const [finalConfirmation, setFinalConfirmation] = useState(null)

    useEffect(() => {
        setItemReview((data && ("review" in data)) ? data.review : review)
    }, [data, review])
    
    const onSectionItemFail = () => { 
        let nextStatus = ""

        if(itemReview !== "incomplete")
            nextStatus = "incomplete"
        else 
            nextStatus = null

        setItemReview(nextStatus)
        props.onStatusChange({
            ...data,
            ...{review : nextStatus}
        })
    }

    const onSectionItemPass = () => {
        let nextStatus = ""

        if(itemReview !== "complete")
            nextStatus = "complete"
        else 
            nextStatus = null

        setItemReview(nextStatus)
        props.onStatusChange({
            ...data,
            ...{review : nextStatus}
        })
    }

    const onConfirmationFail = () => {
        setFinalConfirmation("incomplete")
    }

    const onConfirmationPass = () => {
        setFinalConfirmation("complete")
    }

    let index = 0;

    for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {

            if(key === "review" || key === "mappingKey")
                continue

            const componentId = key.toLowerCase().replace(/ +/g,'')

            if(key === "title") { 
                elements.unshift(
                    <div key={"data-review-"+componentId} className="row bottomMarginNormal bltReviewFormItem">
                        <div className={"col-lg-8 bltReviewFormItemHeader"}>
                            <b>{data[key]}</b>
                        </div>
                    </div>
                )

                continue
            }

            elements.push(
                <div key={"data-review-"+componentId} className="bltReviewFormItem">
                    <div className="row">
                        <div className={"col-lg-4 hideOverflow"}>
                            <b>{key}</b>
                        </div>
                        <div className={"col-lg-6 hideOverflow"}>
                            {strJSX(data[key])}
                        </div>
                        {(!index && !hideDecisionCheckbox) && <div className={"col-lg-2"}>
                            <button 
                                key={`${componentId}-fail`}
                                id={`${componentId}-fail`}
                                className={"bltReviewFormItemCheckMark" + (itemReview === "incomplete" ? " bltReviewFormItemCheckMarkFail" : "")} 
                                onClick={() => onSectionItemFail(key)}
                                disabled={isReadOnly}
                            >
                                <i className="fa fa-2x fa-times-circle"></i>
                            </button>
                            <button
                                key={`${componentId}-pass`} 
                                id={`${componentId}-pass`}
                                className={"bltReviewFormItemCheckMark" + (itemReview === "complete" ? " bltReviewFormItemCheckMarkPass" : "")} 
                                onClick={() => onSectionItemPass(key)}
                                disabled={isReadOnly}
                            >
                                <i className="fa fa-2x fa-check-circle"></i>
                            </button>
                        </div>}                    
                    </div>  
                    {documentData ? (
                            <>
                        <div className="row">
                            <div className={"col-lg-4 hideOverflow"}><b>Received Date:</b> </div>
                            <div className={"col-lg-6 hideOverflow"}> {humanReadableDate(documentData.createdDate)}</div>
                        </div>
                        <div className="row">
                            <div className={"col-lg-4 hideOverflow"}><b>Uploaded by:</b></div>
                            <div className={"col-lg-6 hideOverflow"}>{documentData.createdBy}</div>
                        </div>
                        </>
                    ) : null}
                </div> 
            )
            index++
        }
    }

    const componentId = "no-data"

    if(elements.length === 0) { 
        elements.push(
        <div key={"data-review-no-data"} className="row bottomMarginNormal bltReviewFormItem">
            <div className={"col-lg-10"}>
                NO DATA
            </div>
            {(!index && !hideDecisionCheckbox) && <div className={"col-lg-2"}>
                <button 
                    id={`${componentId}-fail`}
                    className={"bltReviewFormItemCheckMark" + (itemReview === "incomplete" ? " bltReviewFormItemCheckMarkFail" : "")} 
                    onClick={() => onSectionItemFail()}
                    disabled={isReadOnly}
                >
                    <i className="fa fa-2x fa-times-circle"></i>
                </button>
                <button 
                    id={`${componentId}-pass`}
                    className={"bltReviewFormItemCheckMark" + (itemReview === "complete" ? " bltReviewFormItemCheckMarkPass" : "")} 
                    onClick={() => onSectionItemPass()}
                    disabled={isReadOnly}
                >
                    <i className="fa fa-2x fa-check-circle"></i>
                </button>
            </div>}
        </div>) 
    }

    if(showConfirmation) {
        elements.push(
            <div key={`data-review-confirmation`} className="row bottomMarginNormal bltReviewFormItemConfirmation">
                <div className={"col-lg-10 hideOverflow title"}>
                    <b>{confirmationMessage ? confirmationMessage : `Is this section complete and correct?`}</b>
                </div>
                <div className={"col-lg-2"} style={{textAlign:"end"}}>
                    <button 
                        key={`confirmation-fail`}
                        id={`confirmation-fail`}
                        className={"bltReviewFormItemCheckMark" + (finalConfirmation === "incomplete" ? " bltReviewFormItemCheckMarkFail" : "")} 
                        onClick={() => onConfirmationFail()}
                        disabled={isReadOnly}
                    >
                        <i className="fa fa-2x fa-times-circle"></i>
                    </button>
                    <button
                        key={`confirmation-pass`} 
                        id={`confirmation-pass`}
                        className={"bltReviewFormItemCheckMark" + (finalConfirmation === "complete" ? " bltReviewFormItemCheckMarkPass" : "")} 
                        onClick={() => onConfirmationPass()}
                        disabled={isReadOnly}
                    >
                        <i className="fa fa-2x fa-check-circle"></i>
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div className="bltReviewForm" style={{marginBottom:"1em"}}>
           {elements}
        </div>
    )
}

export default BLTReviewForm
